import { ajax } from "../../../../../plugins/api";

export const tickets = {
    all: data => ajax.get(`admin/support/tickets`, data),
    get: id => ajax.get(`admin/support/tickets/${id}`),
    accept: id => ajax.put(`admin/support/tickets/${id}/accept`),
    update: (id, data, vmId = null, scope = "form") => ajax.put(`admin/support/tickets/${id}`, data, vmId, scope),
    sendMessage: (id, data, vmId = null, scope = "form") =>
        ajax.post(`support/tickets/${id}/messages`, data, vmId, scope),
    getMessages: (ticketId, lastMessageId = null) =>
        ajax.get(`support/tickets/${ticketId}/messages`, { infinity_pagination_id: lastMessageId }),
    uploadFile: file => ajax.post()
};
